export default __webpack_public_path__ + "static/media/svg-4.e1e1bbeb.svg";